import { Auth, Users, Plants, Notifications, Configuration, Permissions, Roles } from './routes';
import { $http } from './config';

const ptCoreClient = {
	baseURL: '',
	token: '',
	interceptors: $http.interceptors,
	...Auth,
	...Users,
	...Plants,
	...Notifications,
	...Configuration,
	...Permissions,
	...Roles,
	$http
};

export default ptCoreClient;
